export class ForgotPasswordModel {
    emailId: string | undefined;
}